import { useQuota } from '@/lib/api/queries';
import { cn } from '@/lib/cn';
import { formatInt } from '@/lib/format';

/**
 * Le quota est visible en permanence : c'est la ressource rare du produit
 * (30 000 requêtes/mois) et la première chose à vérifier avant de lancer.
 */
export function QuotaBadge() {
  const { data } = useQuota();
  if (!data) return null;

  const tone = data.exceeded
    ? 'bg-tint-pink text-danger'
    : data.warning
      ? 'bg-tint-purple text-purple'
      : 'bg-sunken text-secondary';

  return (
    <span
      className={cn('rounded-full px-3 py-1 text-xs font-semibold tabular-nums', tone)}
      title={`Période ${data.period}`}
    >
      Quota {formatInt(data.used)} / {formatInt(data.limit)}
      {data.exceeded ? ' — atteint' : ''}
    </span>
  );
}
